import React, { useState } from 'react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import SearchableSelect from '../ui/SearchableSelect';
import '../../styles/components/AccountPage.css';

export interface ProjectOption { project_id: string; project_name: string }

interface ChooseProjectDialogProps {
  open: boolean;
  /** Dialog title, e.g. "New vendor". */
  title: string;
  /** What is being added, for the sentence under the title: "vendor", "event". */
  what: string;
  /** Projects this person may add it to. */
  projects: ProjectOption[];
  /** The project to preselect, when it is one of the options. */
  activeProjectId: string | null;
  busy?: boolean;
  onClose: () => void;
  onContinue: (projectId: string) => void;
}

/**
 * Vendors and events belong to a project, so New vendor / New event on an
 * account-level page first asks which one. The caller then opens that
 * project's form (switching into the project when it is not the active one).
 */
export const ChooseProjectDialog: React.FC<ChooseProjectDialogProps> = ({
  open, title, what, projects, activeProjectId, busy = false, onClose, onContinue,
}) => {
  const initial = projects.find(p => p.project_id === activeProjectId)?.project_id ?? projects[0]?.project_id ?? '';
  const [projectId, setProjectId] = useState(initial);
  const chosen = projects.some(p => p.project_id === projectId) ? projectId : initial;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="small"
      footer={(
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button variant="primary" onClick={() => onContinue(chosen)} disabled={!chosen} loading={busy}>Continue</Button>
        </>
      )}
    >
      <p className="ap-dialog-note">Which project is this {what} for? A {what} belongs to a project, so the form opens inside it.</p>
      <SearchableSelect
        value={chosen}
        onChange={setProjectId}
        options={projects.map(p => ({ value: p.project_id, label: p.project_name }))}
        ariaLabel="Project"
      />
    </Modal>
  );
};

export default ChooseProjectDialog;
